import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import themeTokens from './themeTokens';

export const ADMIN_THEME_CLASSNAME = 'theme-admin';

const GlobalThemeToken = createGlobalStyle`
    html.${ADMIN_THEME_CLASSNAME} {
        /* font sizes */
        --button-font-size: ${themeTokens.buttonFontSize};
        --input-font-size: ${themeTokens.inputFontSize};

        /* input field */
        --input-height: ${themeTokens.inputFieldHeight};
        
        --calculator-form-item-error-border: 1px var(--ant-error-color) solid;

        --calculator-field-background-color: rgba(0, 0, 0, 0.07);
        --calculator-field-label-padding: 0 11px;
        --calculator-field-label-color: rgba(0, 0, 0, 0.85);
        --calculator-field-disabled-label-color: rgba( 0 , 0 , 0 , 0.25);
        --calculator-field-padding: 10px 5px;
        --calculator-grid-item-gap: 10px;
        --calculator-grid-item-min-height: min-content;
        
        --calculator-comparison-form-item-height-default: 57px;
        --calculator-comparison-form-item-height-second: 57px;
        --calculator-comparison-below-condition-background: #f5f5f5;
        --calculator-comparison-form-item-ant-typography-padding-left-right: 11px;
        --calculator-comparison-mobile-form-item-padding-top: 45px;
        --calculator-comparison-mobile-form-item-padding-top-sm: 45px;
        --calculator-comparison-form-item-error-position: absolute;
        --calculator-comparison-vehicle-image-height: 337px;
        --calculator-comparison-vehicle-image-height-xl: 179px;
        --calculator-comparison-vehicle-image-height-lg: 121px;
        --calculator-comparison-vehicle-image-height-m: 85px;
        --calculator-comparison-vehicle-image-height-sm: 85px;
        --datepicker-label-padding-form-item: 2px 0px 8px;
    }
`;

const AdminGlobalStyles = () => {
    useEffect(() => {
        document.documentElement.classList.add(ADMIN_THEME_CLASSNAME);

        return () => {
            document.documentElement.classList.remove(ADMIN_THEME_CLASSNAME);
        };
    }, []);

    return <GlobalThemeToken />;
};

export default AdminGlobalStyles;
